import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import type { AssistantLinkTarget } from '@core/tellent-assistant-types';
import { TellentAssistantLinkDirective } from '@core/tellent-assistant-ui';
import { IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-assistant-list-card',
  imports: [IconComponent, TellentAssistantLinkDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="content"><ng-content /></div>
    <rt-icon name="open-in-new" class="hover-affordance" />
    @if (linkTarget(); as target) {
      <a
        class="open-link"
        [tellentAssistantLink]="target"
        target="_blank"
        rel="noopener noreferrer"
        [attr.aria-label]="label()"
      ></a>
    } @else if (url(); as href) {
      <a
        class="open-link"
        [href]="href"
        target="_blank"
        rel="noopener noreferrer"
        [attr.aria-label]="label()"
      ></a>
    }
  `,
  styleUrl: './list-card.component.less',
  host: {
    '[class.interactive]': '!!linkTarget() || !!url()',
  },
})
export class ListCardComponent {
  /** Structured in-app destination; activation can be taken over by a host-provided opener. */
  public readonly linkTarget = input<AssistantLinkTarget | null>(null);
  /** Raw external URL (sources, model-provided links); never intercepted. */
  public readonly url = input<string | null>(null);
  public readonly label = input<string | null>(null);
}
